import React from "react";

/**
 * Renders a big pencil icon as an SVG element.
 *
 * @param {object} cls - The class name for styling the SVG element.
 * @return {JSX.Element} The big pencil icon as an SVG element.
 */
const BigPencilIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M21.1138 2.88663C20.5452 2.31888 19.7745 2 18.971 2C18.1675 2 17.3968 2.31888 16.8282 2.88663L3.22531 16.4898C2.83577 16.8772 2.5269 17.3379 2.31658 17.8454C2.10626 18.3529 1.99866 18.8971 2.00001 19.4465V21.1636C2.00001 21.3854 2.08813 21.5982 2.24498 21.755C2.40183 21.9119 2.61457 22 2.83639 22H4.55348C5.10278 22.0015 5.64694 21.8941 6.15444 21.6839C6.66195 21.4737 7.12272 21.165 7.51008 20.7755L21.1138 7.1715C21.6813 6.60291 22 5.8324 22 5.02907C22 4.22573 21.6813 3.45522 21.1138 2.88663ZM6.32744 19.5928C5.85573 20.0614 5.21837 20.3253 4.55348 20.3272H3.67277V19.4465C3.67193 19.1168 3.73647 18.7903 3.86266 18.4858C3.98886 18.1813 4.17419 17.9049 4.40795 17.6725L14.7314 7.34881L16.6551 9.27253L6.32744 19.5928ZM19.9303 5.98883L17.8344 8.08568L15.9107 6.16615L18.0075 4.0693C18.1338 3.94326 18.2837 3.84334 18.4486 3.77523C18.6135 3.70712 18.7903 3.67217 18.9687 3.67236C19.1471 3.67256 19.3238 3.7079 19.4886 3.77636C19.6534 3.84483 19.803 3.94508 19.9291 4.07139C20.0551 4.1977 20.155 4.3476 20.2231 4.51254C20.2912 4.67747 20.3262 4.8542 20.326 5.03263C20.3258 5.21107 20.2905 5.38773 20.222 5.55251C20.1535 5.71729 20.0533 5.86697 19.927 5.99301L19.9303 5.98883Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BigPencilIcon;
